var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ActionButton',{attrs:{"icon":"icon-up"},on:{"click":_vm.copyNtoFN}},[_vm._v("\n\t"+_vm._s(_vm.t('contacts', 'Copy to full name'))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }